export default "__VITE_ASSET__Tlb40kyz__"